import React from 'react';
import { Link } from 'react-router-dom';

const Abled = () => {
  return (
    <div>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-abled.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Inclusion of Differently Abled</h1>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>Inclusion of Differently Abled</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row mt-n2-9">
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div className="widget mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    <li><Link to="/skill-development">Skill Development<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/education">Education<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/health">Health<i className="ti-arrow-right"></i></Link></li>
                    <li className="active"><Link to="/abled">Inclusion of Differently Abled<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/sports">Sports<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/community-initiatives">Community Initiatives<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/livelihoods">Livelihoods<i className="ti-arrow-right"></i></Link></li>
                  </ul>
                </div>

                <div className="widget mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                      <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                      <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                <div className="mb-1-9 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                  <img src="/img/service/service-details-abled.jpg" alt="..." className="border-radius-10" />
                </div>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Shamayita Math is a strong proponent of developing the highest potential of the differently abled through a special focus and all the required support. Inclusion of differently abled, it believes, is a hallmark of any civilized and empathetic society. Acting on this belief, Shamayita Math operates Shamayita Monodeep School, a dedicated school for the differently abled, and is working on the Shamayita Monodeep Residential Project, an accommodation facility for the differently abled and their families.
                </p>

                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Shamayita Monodeep School:</h2>
                  <div className="row align-items-center mb-1-9">
                    <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img
                          src="/img/service/abled-1.jpg"
                          alt="Shamayita Monodeep"
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-0">
                        The school is dedicated to educating and serving children with various conditions including Autism Spectrum Disorder (ASD), Intellectual Disability, and Down Syndrome. The school aims to develop an understanding, support, and inclusion of individuals with the above conditions in the broader society through an individual-specific integration program.
                      </p>
                    </div>
                    <div className="col-12">
                      <p className="mb-0">
                        It provides a safe and sensitive environment for the students emphasizing its compassionate value so that the students can develop their innate and latent capabilities and lead a dignified life. The emphasis is on promoting and supporting the development of independence, choice, and self-advocacy for the students. Each student is provided with a consistent, foreseeable, and systematic learning environment, which optimizes learning opportunities while reducing stress and anxiety.
                      </p>
                    </div>
                  </div>

                  <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Key Aspects</h4>

                    <div className="row align-items-center mb-1-9">
                      <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                        <ul className="list-unstyled list-style02 last pb-4 mb-4">
                          <li>Education, care, and support to children with Autism, and Intellectual Disability in a well-developed daycare set-up.</li>
                          <li>Advice, support, and information to families and caregivers.</li>
                          <li>Awareness building on the needs of individuals with ASD and cognitive challenges to raise knowledge and empathy within the society.</li>
                          <li>A comprehensive assessment at the onset evaluates motor skills, cognition, social interaction, language, attention, sensory use, and interests for a tailored approach.</li>
                        </ul>
                      </div>
                      <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                        <div className="image-hover">
                          <img src="/img/service/abled-5.jpg" alt="Key Aspects" className="border-radius-10" />
                        </div>
                      </div>
                    </div>

                    <ul className="list-unstyled list-style02 last pb-4 mb-4">
                      <li>Each child has an individual education program (IEP) with specific goals and identified techniques, customized to their unique needs that are regularly reviewed and updated.</li>
                      <li>A unique integration program with Shamayita Convent School, an adjacent conventional school offering diverse academic and extracurricular opportunities. It allows the students to switch schools based on abilities. Reviewed regularly, this approach is aligned with the New Education Policy 2020.</li>
                      <li>The overall approach and 24-hour curriculum are geared toward a child’s optimum development.</li>
                      <li>Regular check-ups by a general physician, neuropsychiatrist, and other specialists.</li>
                      <li>Parents are regularly updated about school activities. They can also visit and work jointly with teachers. Group meetings and learning sessions are held with parents. Regular home visits by facilitators to ensure that the curriculum is followed at home.</li>
                    </ul>


                  <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Facilities</h4>

                    <div className="row align-items-center mb-1-9">
                      <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                        <div className="image-hover">
                          <img src="/img/service/abled-6.jpg" alt="Facilities" className="border-radius-10" />
                        </div>
                      </div>

                      <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                        <ul className="list-unstyled list-style02 last pb-4 mb-4">
                          <li>Well-equipped classrooms</li>
                          <li>Occupational therapy room</li>
                          <li>Equipment for vestibular stimulation</li>
                          <li>Sensory integration</li>
                          <li>Teaching kitchen</li>
                          <li>Pre-vocational/Vocational training</li>
                          <li>Computers and electronic aids</li>
                          <li>A range of teaching materials</li>
                          <li>Outdoor play area</li>
                          <li>Multi gym equipment</li>
                        </ul>
                      </div>
                    </div>

                  <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Special Activities</h4>

                    <div className="row align-items-center mb-1-9">
                      <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                        <ul className="list-unstyled list-style02 last">
                          <li>Morning and evening prayer.</li>
                          <li>Interactive indoor/outdoor games sessions, and yoga classes.</li>
                          <li>Cooking, gardening, and activities for daily living such as shopping.</li>
                          <li>Cultural programs with students of Shamayita Convent School.</li>
                        </ul>
                      </div>
                      
                      <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                        <div className="image-hover">
                          <img src="/img/service/abled-4.jpg" alt="Special Activities" className="border-radius-10" />
                        </div>
                      </div>
                    </div>

                    <ul className="list-unstyled list-style02 last pb-4 mb-4">
                      <li>Creative activities such as singing, playing musical instruments, dancing, and drawing</li>
                      <li>Picnic with parents, teachers, and siblings, annual excursions, and educational trips.</li>
                      <li>Playing computer games.</li>
                      <li>Celebration of festivals and birthdays.</li>
                    </ul>

                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Teaching Methodology:</h4>

                  <div className="row align-items-center mb-1-9">
                    <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img src="/img/service/abled-teaching-1.jpg" alt="Teaching Method" className="border-radius-10" />
                      </div>
                    </div>

                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-2"><strong>The focus is on students’ engagement, independence, and understanding.</strong></p>
                      <ul className="list-unstyled list-style02 last">
                        <li>Emphasis is on providing a regular, predictable, and structured learning environment, for better learning in a stress-free manner.</li>
                        <li>Very simple language and use of visual cues for easier understanding.</li>
                        <li>Clearly designated areas for different activities.</li>
                        <li>Tasks are presented in visual sequences to promote independence.</li>
                        <li>Age-appropriate activities to engage students.</li>
                      </ul>
                    </div>
                  </div>

                  <div className="mb-1-9 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                    <img src="/img/service/service-details-teaching.jpg" alt="Teaching Details" className="border-radius-10" />
                  </div>


                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">Impacts:</h4>

                  <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="col-md-12 mb-4 mb-md-0">
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">The differently abled students receive inclusive education and equal opportunities.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">With dedicated and focused attention, their learning outcomes improve.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">They actualize their potential, thus developing better self-esteem.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">They are prepared to be an active member of the mainstream society.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">They can aspire to have a fulfilling career for themselves.</span>
                      </div>
                    </div>
                  </div>

                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Shamayita Monodeep Residential Project:</h2>

                  <div className="row align-items-center mb-1-9">
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-0">
                        Since the integration of differently abled children and their families into mainstream society is not always a smooth one, Shamayita Math is coming up with the Mondeep Residential project. It will be a space, where such children could stay with their families and integrate with the Math as its extended family. The efforts center around connecting them with different programs of the Math. Shamayita Math’s members including the parents of the differently abled will regularly serve the differently abled, apart from working on different initiatives and derive peace and happiness through this work. This will root them deeply within the Math and develop a feeling of ownership in them.
                      </p>
                    </div>
                    <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img
                          src="img/service/abled-7.jpg"
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                  </div>


                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="150ms">Highlights of the Project</h4>

                  <ul className="list-unstyled list-style02 last">
                    <li>Trained caregivers will be available 24x7.</li>
                    <li>Provisions of elevator and 24x7 CCTV surveillance.</li>
                    <li>Community kitchen and common dining hall.</li>
                    <li>4000 sq. ft. area for park, playground, and walking path.</li>
                    <li>Splash pool, sensory path, and other therapy arrangements.</li>
                    <li>A suitable balance between indoor and outdoor activities.</li>
                    <li>
                      Activities designed by special educators, and experienced professionals of
                      Monodeep School to improve the mental, physical, and social health and
                      daily living skills of children.
                    </li>
                    <li>
                      Peaceful environment with an abundance of greenery for motor-sensory,
                      emotional, and social benefits for children.
                    </li>
                    <li>
                      Medical facilities such as diagnostic tests, surgery, and ambulance support.
                    </li>
                    <li>
                      Agriculture farms and orchards for regular supply of farm-fresh vegetables
                      and seasonal fruits.
                    </li>
                    <li>Regular prayer and meditation to promote peace and calmness.</li>
                    <li>
                      Opportunity to raise knowledge levels through a rich selection of books in
                      the library.
                    </li>
                  </ul>


                <h4 className="mb-4 wow fadeInUp pt-2" data-wow-delay="150ms">Envisioned Impacts</h4>

                  <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="col-md-12 mb-4 mb-md-0">
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">
                          The dedicated residential facility will ensure suitable and comfortable
                          living conditions for differently abled children and their families for
                          better life quality.
                        </span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">
                          With regular interaction with peers with similar challenges, a strong
                          sense of friendliness will develop, reducing their isolation.
                        </span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2 mb-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">
                          The support of members of the Math will ease off the responsibility on
                          the families of the differently abled.
                        </span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-2">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">
                          With care and support, the differently abled will develop confidence and
                          skills for independent living and employment in the future.
                        </span>
                      </div>
                    </div>
                  </div>
                  
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>

    </div>
  );
};

export default Abled;
